import { toNumber } from 'lodash'
import { useTranslation } from 'react-i18next'

import { isQaMetricId } from 'config/domain/qa.config'

import { DateHelper } from 'lib/utils/date.helper'

export const useValidators = () => {
  const { t } = useTranslation()

  const validateMetric = (metric: string) => {
    if (isQaMetricId(metric)) {
      return true
    }

    return t('features.mission.create-mission.fields.metric.errors.invalid-question', {
      metric,
    })
  }

  const validateTarget = (target: number) => {
    const parsedTarget = toNumber(target)
    if (Number.isNaN(parsedTarget)) {
      return t('features.mission.create-mission.fields.target.errors.nan')
    }
    // Target cannot be 0
    if (parsedTarget === 0) {
      return t('features.mission.create-mission.fields.target.errors.cannot-be-zero')
    }

    if (parsedTarget < 0) {
      return t('features.mission.create-mission.fields.target.errors.qa-min', {
        min: 1,
      })
    }

    if (parsedTarget > 100) {
      return t('features.mission.create-mission.fields.target.errors.qa-max', {
        max: 100,
      })
    }

    return true
  }

  const validateStartDate = (startDate: Date | null) => {
    const today = new Date()

    if (startDate && startDate > today) {
      return t('features.mission.create-mission.fields.start-date.errors.future-date')
    }

    return true
  }

  const validateEndDate = (startDate: Date, endDate: Date) => {
    // Don't validate the end date if the start date has not been set yet
    if (startDate == null) {
      return true
    }

    const today = new Date()
    today.setHours(0, 0)
    const daysDifference = DateHelper.getDaysBetweenDates(startDate, endDate)

    if (endDate < today) {
      return t('features.mission.create-mission.fields.end-date.errors.past-date')
    }

    if (daysDifference < 1) {
      return t('features.mission.create-mission.fields.end-date.errors.minimum-duration')
    }

    return true
  }

  const validateDueDate = (dueDate: Date) => {
    const today = new Date()
    today.setHours(0, 0)
    const daysDifference = DateHelper.getDaysBetweenDates(today, dueDate)

    if (dueDate < today) {
      return t('features.mission.create-mission.fields.end-date.errors.past-date')
    }

    if (daysDifference < 1) {
      return t('features.mission.create-mission.fields.end-date.errors.minimum-duration')
    }
    return true
  }
  return {
    validateMetric,
    validateTarget,
    validateStartDate,
    validateEndDate,
    validateDueDate,
  }
}
